import { Cache } from 'aws-amplify'
import React from 'react'
import { getDogNames } from 'utils/common-utils'

export const replaceTemplateDogName = (text: string | React.ReactNode | undefined): string => {
  const { dog: json } =
    typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('persist:root') || '{}') : {}
  const dog = json ? JSON.parse(json) : null
  const dogName = getDogNames(dog?.dogInfo?.dogs) || Cache.getItem('dogName')

  return (
    text?.toString().replace(/\[dog\.name\]/g, () => {
      return dogName || `your dog`
    }) || ``
  )
}
